export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 76 76" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-922.000000, -5052.000000)">
                    <g id="编组-2" transform="translate(510.000000, 4798.000000)">
                        <g id="TV_icon" transform="translate(412.000000, 254.000000)">
                            <rect id="矩形" x="0" y="0" width="76" height="76"></rect>
                            <g id="编组-9" transform="translate(7.000000, 14.000000)" stroke="#000000" strokeWidth="2">
                                <polyline
                                    id="路径"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    points="39.6949814 45.9459459 39.6949814 40.4324324 23.1544409 40.4324324 23.1544409 45.9459459"
                                ></polyline>
                                <path
                                    d="M3.28896039,0 L59.1975261,0 C61.0140702,0 62.4864865,1.50852189 62.4864865,3.36961019 L62.4864865,37.5425438 C62.4864865,39.1387256 61.2237438,40.4324324 59.6657658,40.4324324 L3.28896039,40.4324324 C1.47241623,40.4324324 0,38.9239105 0,37.0628222 L0,3.36961019 C0,1.50852189 1.47241623,0 3.28896039,0 Z"
                                    id="Stroke-301"
                                ></path>
                                <line
                                    x1="14.343324"
                                    y1="46.8648649"
                                    x2="47.4244051"
                                    y2="46.8648649"
                                    id="Stroke-302"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                ></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
